import { render, staticRenderFns } from "./reasonWrite.vue?vue&type=template&id=7933973e&scoped=true"
import script from "./reasonWrite.vue?vue&type=script&lang=js"
export * from "./reasonWrite.vue?vue&type=script&lang=js"
import style0 from "./reasonWrite.vue?vue&type=style&index=0&id=7933973e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7933973e",
  null
  
)

export default component.exports